import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';

export interface NonUnionInitialValues {
  isLoggedIn: boolean;
  isPreRegistration: boolean;
  loadedPrevRegistration: boolean;
  mode: {new: boolean; edit: boolean; detail: boolean};
  isSupplyCommencementEditable: boolean;
  preFilledForm: object | undefined;
}

export const INITIAL_VALUES = new InjectionToken<NonUnionInitialValues>('initial.values');
export const FIXED_VALUES_OBS = new InjectionToken<Observable<NonUnionInitialValues | undefined>>('FIXED_VALUES_OBS');

export const ROUTER_BASE_PATH = new InjectionToken<string>('ROUTER_BASE_PATH');
